import dhtmlXTabBar from './dhtmlXTabBar';
import './dhtmlXTabBarExtend';

export default dhtmlXTabBar;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTabBar/index.js